
import Component, { mixins } from "vue-class-component"
import moment from "moment"
import { AbholzeitType } from "@/entities/common/enums"
import FilialeHeader from "../custom/FilialeHeader.vue"
import NichtGueltig from "../custom/NichtGueltig.vue"
import TerminLieferungLogic from "@/logic/bestellung_neu/termin_lieferung_logic"
import Calculator from "../mixins/Calculator.vue"
import ErrorBox from "../custom/ErrorBox.vue"

@Component({ components: { FilialeHeader, NichtGueltig, ErrorBox } })
export default class TerminLieferung extends mixins(Calculator) {
  logic: TerminLieferungLogic = null

  dateMenuVisible: boolean = false
  timeMenuOpen: boolean = false

  get terminPanelVisible(): boolean {
    if (this.logic.selectedLieferType == AbholzeitType.UHRZEIT) return true
    return false
  }

  weiter() {
    this.logic.weiter()
  }

  formatSelectedDate(): string {
    if (this.logic.selectedDate == null) return null
    return this.formatDate(this.logic.selectedDate)
  }

  formatDate(data: string): string {
    moment.locale("de")
    return moment(data).format("LL")
  }

  allowedDates(val) {
    let result = false
    this.logic.geoeffneteTage.forEach((toCompare) => {
      if (toCompare.datum == val) {
        result = true
      }
    })
    return result
  }

  terminBearbeiten() {
    this.logic.terminBearbeiten()
  }

  terminAuswaehlen() {
    this.logic.terminAuswaehlen()
  }

  mounted() {
    this.logic = new TerminLieferungLogic()
    this.logic.init()
  }
}
